import { Spin } from "antd";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setAppVisibility, setUserMe } from "../../../../core/actions/app";
import { Constants } from "../../../../core/helpers/constants";
import {
  setStorage,
  storageVposResult,
} from "../../../../core/helpers/storage";
import { SubscriptionState } from "../../../../core/models/enums/subscriptionState";
import AuthService from "../../../../core/services/auth.service";
import UserService from "../../../../core/services/user.service";
import "./PayByMeSuccessPage.scss";

const userService = new UserService();
const authService = new AuthService();

const PayByMeSuccessPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    setStorage(storageVposResult, Constants.vposResultSuccess);
    window.parent.postMessage("payment-success", "*");
    const fetchMe = async () => {
      const intervalId = setInterval(async () => {
        const userMeDto = await userService.getDetails();
        if (userMeDto.subscriptionState === SubscriptionState.ACTIVE) {
          setUserMe(userMeDto)(dispatch);
          await authService.refresh();
          setAppVisibility(true)(dispatch);
          clearInterval(intervalId);
        }
      }, 1000);
    };
    fetchMe();
  }, [dispatch]);

  return (
    <div id="pay-by-me-success-page">
      <Spin size="large" />
    </div>
  );
};

export default PayByMeSuccessPage;
